import { Box, Typography, Button } from "@mui/material";
import './styles.css';
import React, { useState } from "react";
import CustomTextField from "../../components/CustomTextField";
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import GroundDetailsTable from "../../components/GroundDetailsTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { isEmpty } from "../../common/StaticExports";
import FacilityStatusSelect from "../../components/FacilityStatusSelect";
import CapablitiesAutocomplete from "../../components/CapablitiesAutocomplete";

const AddFacilitiesForm = (props:any) => {
    const { onCancelClick, onCreateClick } = props;
    const [addGroundDetails, setAddGroundDetails] = useState(false);
    const initialData = {
        "id": null,
        "facilityName": "",
        "shortName": "",
        "address": "",
        "owner": "",
        "facilityStatus": "",
        "capabilities": [],
        "dormitoryRemarks": "",
        "facilityGrounds": [
            {
            "id": null,
            "name": "",
            "turf": [],
            "illumination": []
            }
        ]
    };
    const [newFacility, setNewFacility]:any = useState(initialData);
    const [t] = useTranslation();

    const updateState = ((key:any, updatedData:any) => {
        const updatedFacility = {
            ...newFacility,
            [key]: updatedData,
        };
        setNewFacility(updatedFacility);
    });

    return(
        <React.Fragment>
            <Box className='facilitiesFormStyles mb20'>
                <CustomTextField label={t('DC_6_FACILITY_NAME')} value={newFacility?.facilityName} manageChange={(e:any) => {updateState('facilityName', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(newFacility?.facilityName)} />
                <CustomTextField label={t('DC_6_SHORT_NAME')} value={newFacility?.shortName} manageChange={(e:any) => {updateState('shortName', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(newFacility?.shortName)} />
                <CustomTextField label={t('DC_6_ADDRESS')} value={newFacility?.address} manageChange={(e:any) => {updateState('address', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(newFacility?.address)} />
                <CustomTextField label={t('DC_6_OWNER')} value={newFacility?.owner} manageChange={(e:any) => {updateState('owner', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(newFacility?.owner)} />
                <FacilityStatusSelect value={newFacility?.facilityStatus} manageSelect={(e:any) => {updateState('facilityStatus', e)}} isError={isEmpty(newFacility?.facilityStatus)} errorMessage={t('REQUIRED')} />
                <CapablitiesAutocomplete selectedValues={newFacility?.capabilities ? newFacility?.capabilities : []} manageSelect={(e:any) => {updateState('capabilities', e)}} />
                <CustomTextField label={t('DC_6_N_OF_CHANGING_ROOMS')} type='number' value={newFacility?.changingRooms} manageChange={(e:any) => {updateState('changingRooms', parseInt(e))}} errorMessage={t('REQUIRED')} isError={isEmpty(newFacility?.changingRooms)} />
                <CustomTextField label={t('DC_6_DORMITORY_CAPACITY')} type='number' value={newFacility?.dormitoryCapacity} manageChange={(e:any) => {updateState('dormitoryCapacity', parseInt(e))}} errorMessage={t('REQUIRED')} isError={isEmpty(newFacility?.dormitoryCapacity)} />
            </Box>
            <JoyCssVarsProvider>
                <Textarea 
                sx={{ borderRadius: '6px', mt: 0, width: '100%', mb: '20px' }} 
                onChange={(e) => {updateState('dormitoryRemarks', e.target.value)}} placeholder='Dormintory Remarks...' 
                minRows={2} maxRows={2} value={newFacility?.dormitoryRemarks}/>
            </JoyCssVarsProvider>
            <Box className={'mb20'}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography className='standardsHeading uppercase'>Ground Details</Typography>
                    <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addGroundDetails} variant='contained' size='small' onClick={() => {setAddGroundDetails(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                        {'Add ground details'}
                    </Button>
                </Box>
                <Box>
                    <GroundDetailsTable 
                    data={newFacility?.facilityGrounds ? newFacility?.facilityGrounds : []}
                    addData={addGroundDetails} 
                    handleClick={() => setAddGroundDetails(false)}
                    updateList={(e:any) => {updateState('facilityGrounds', e)}}/>
                </Box>
            </Box>
            <Box className={'mb40'} sx={{ display: 'flex', ml: 'auto', float: 'right' }}>
                <Button className='smallButton closeCancelButtonStyles' variant='contained' sx={{ mr: 2 }} disableElevation disableRipple onClick={() => onCancelClick()}>Cancel</Button>
                <Button className='smallButton' variant='contained' disableElevation disableRipple onClick={() => {onCreateClick(newFacility)}}>Add</Button>
            </Box>
        </React.Fragment>
    )
}

export default AddFacilitiesForm;